import { render, staticRenderFns } from "./deleteBasePrivilege.vue?vue&type=template&id=05340131"
import script from "./deleteBasePrivilege.vue?vue&type=script&lang=js"
export * from "./deleteBasePrivilege.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports